import { waitUntil } from 'atc-js';
import hasDom from 'has-dom';

const window = globalThis;

// TODO: ...maybe move this whole thing to atc-js?

function debugLog(action, ...args) {
    if (hasDom() && typeof window !== 'undefined') {
        const { searchParams } = new URL(window.location.href);
        const isDebugMode = searchParams.get('caiEventBusDebug');

        if (isDebugMode) {
            const filteredArgs = args.filter((arg) => typeof arg !== 'function');
            console.log('CAI Event Bus: ', action, ...filteredArgs);
        }
    }
}

function isEventBusInitialized() {
    return hasDom() && typeof window !== 'undefined' && window.caiEventBus;
}

async function ensureEventBus() {
    return new Promise((resolve, reject) => {
        waitUntil(
            isEventBusInitialized,
            () => resolve(window.caiEventBus),
            50,
            50000,
            () => {
                console.log('CAI Event Bus: mitt.umd.js is not loaded');
                reject();
            },
        );
    })
}

async function events(action, ...args) {
    const eventBus: any = await ensureEventBus();
    if (eventBus) {
        if (action === 'unlistenAll') {
            eventBus.all.clear();
            console.log('CAI Event Bus: cleared all events');
        } else if (action === 'check') {
            return eventBus.all.get(...args);
        } else if (eventBus[action]) {
            eventBus[action](...args);
        }
        debugLog(action, ...args);
    } else {
        console.error('window.caiEventBus does not exist');
    }
}

export default {
    listen: (name, callback) => events('on', name, callback),
    unlisten: (name, callback) => events('off', name, callback),
    unlistenAll: () => events('unlistenAll'),
    send: (name, payload) => events('emit', name, payload),
    checkEvent: (name) => events('check', name),
    debugLog,
};